// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEventListBody = {
  leagueId: string;
  day: string;
  timeZone: string;
  conferenceKey?: string | null;
};

export type typeEventListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    leagueId: string;
    day: string;
    timeZone: string;
    events: {
      eventId: string;
      leagueId: string;
      seasonId: string;
      kickoffAt: string;
      status:
        | "scheduled"
        | "inProgress"
        | "final"
        | "postponed"
        | "canceled"
        | "delayed";
      statusLabel: string;
      statusDetail?: string | null;
      isLive: boolean;
      isKickoffPassed: boolean;
      winnerTeamId?: string | null;
      isTie: boolean;
      home: {
        teamId: string;
        name: string;
        abbreviation: string;
        logoMediaId?: string | null;
        primaryColorHex?: string | null;
        score?: number | null;
        recordLabel?: string | null;
        logoUrl?: string | null;
        shortName?: string | null;
        pollRankLabel?: string | null;
      };
      away: {
        teamId: string;
        name: string;
        abbreviation: string;
        logoMediaId?: string | null;
        primaryColorHex?: string | null;
        score?: number | null;
        recordLabel?: string | null;
        logoUrl?: string | null;
        shortName?: string | null;
        pollRankLabel?: string | null;
      };
      liveState?: {
        possessionTeamId?: string | null;
        baseball?: {
          balls: number;
          strikes: number;
          outs: number;
          isFirstOccupied: boolean;
          isSecondOccupied: boolean;
          isThirdOccupied: boolean;
          countLabel: string;
          outsLabel: string;
          pitcher?: { name: string; lineLabel: string | null } | null;
          batter?: { name: string; lineLabel: string | null } | null;
        } | null;
        football?: {
          ballSpotLabel: string;
          ballSpotPercentFromAway: number;
          firstDownPercentFromAway?: number | null;
          driveStartPercentFromAway?: number | null;
          driveSummaryLabel?: string | null;
        } | null;
        summaryLabel: string;
        downAndDistanceLabel?: string | null;
        hockey?: { powerPlayTeamId: string; powerPlayLabel: string } | null;
      } | null;
      startingPitchers?: {
        away?: {
          name: string;
          playerId?: string | null;
          record?: string | null;
          era?: string | null;
        } | null;
        home?: {
          name: string;
          playerId?: string | null;
          record?: string | null;
          era?: string | null;
        } | null;
      } | null;
      hasAlertsOn?: boolean;
      pregameLine?: { label: string; spokenLabel: string } | null;
    }[];
    refreshAfterSeconds: number;
    conferenceKey?: string | null;
  };
};

export type typeEventListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEventListBody = {
  type: "object",
  properties: {
    leagueId: { type: "string", maxLength: 3000, minLength: 1 },
    day: { type: "string", maxLength: 3000, minLength: 1 },
    timeZone: { type: "string", maxLength: 3000, minLength: 1 },
    conferenceKey: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["leagueId", "day", "timeZone"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEventList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEventListBody);
  }

  return async function postEventList(
    payload: typeEventListBody,
  ): Promise<typeEventListOutput200 | typeEventListOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEventList" failed before calling the network. #a05dc7dab986`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#a05dc7dab986" },
        },
        data: null,
      } as typeEventListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/event/list`,
      httpMethod: "POST",
      options,
    })) as typeEventListOutput200 | typeEventListOutput400;
  };
}
